import {Controller} from '@stubhub/react-store-provider';

const responsiveListenerToDeviceTypeMap = {
  small: 'phone',
  medium: 'desktop',
  large: 'desktop',
  extraLarge: 'desktop',
};

/**
 * Based on media queries included in '@stubhub/react-responsive-listener'
 * - import {mediaQueries} from '@stubhub/react-responsive-listener';
 *
 * @type {Controller}
 */
const controller = new Controller({
  namespace: 'device',
  reducers: [
    {
      action: 'UPDATE_SCREEN_SIZE',
      handler: load,
    },
    {
      action: 'EVENT:LOADING',
      handler: eventLoad,
    },
  ],
});

function load(state, action) {
  const device = state && state.device;
  const screenSize = action && action.screenSize;

  screenSize && (device.type = responsiveListenerToDeviceTypeMap[screenSize] || 'desktop');

  return controller.setLocalState({...state, device}, action);
}

function eventLoad(state) {
  return load(state, state.viewport);
}

export default controller;
